import GeneralError from '@/pages/errors/general-error.tsx'
import { RouteObject } from 'react-router-dom'

export const teamLeaderRoute: RouteObject[] = [
  {
    path: 'team-leader',
    children: [
      {
        path: 'dashboard',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/dashboard/index.tsx'))
            .default,
        }),
      },
      {
        path: 'projects',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/projects/index.tsx'))
            .default,
        }),
      },
      {
        path: 'tasks',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/tasks/index.tsx'))
            .default,
        }),
      },
      {
        path: 'employees',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/employees/index.tsx'))
            .default,
        }),
      },
      // NEW: Messages
      {
        path: 'messages',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/messages/index.tsx'))
            .default,
        }),
      },
      {
        path: 'time-tracking',
        lazy: async () => ({
          Component: (
            await import('../pages/team-leader/time-tracking/index.tsx')
          ).default,
        }),
      },
      {
        path: 'configuration/alerts',
        lazy: async () => ({
          Component: (await import('../pages/configuration/alerts/index.tsx'))
            .default,
        }),
      },
      {
        path: 'reports',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/reports/index.tsx'))
            .default,
        }),
      },
      {
        path: 'team-schedule',
        lazy: async () => ({
          Component: (
            await import('../pages/team-leader/team-schedule/index.tsx')
          ).default,
        }),
      },
      {
        path: 'quality-inspections',
        lazy: async () => ({
          Component: (
            await import('../pages/team-leader/quality-inspections/index.tsx')
          ).default,
        }),
      },
      {
        path: 'notifications',
        lazy: async () => ({
          Component: (
            await import('../pages/team-leader/notifications/index.tsx')
          ).default,
        }),
      },
      // Team Leader Settings
      {
        path: 'settings',
        lazy: async () => ({
          Component: (await import('../pages/team-leader/settings/index.tsx')).default,
        }),
        errorElement: <GeneralError />,
      },
    ],
  },
]